import React, { createContext, useContext, useState } from 'react';

export enum PortfolioFormSteps {
  NAME_PORTFOLIO = 1,
  COPY_AND_PASTE_CUSIPS = 2,
  REVIEW_UNKNOWNS = 3,
  ADD_OPTIONAL_DATA = 4,
}

export const useStepForm = (isEditing) => {
  const [currentStep, setCurrentStep] = useState<PortfolioFormSteps>(
      isEditing ? PortfolioFormSteps.COPY_AND_PASTE_CUSIPS : PortfolioFormSteps.NAME_PORTFOLIO,
  );

  const goNext = () => setCurrentStep((prev) => prev + 1);
  const goPrev = () => setCurrentStep((prev) => prev - 1);

  return {
    currentStep,
    goNext,
    goPrev,
    setCurrentStep,
  };
};

type StepFormContextType = ReturnType<typeof useStepForm>;

export const StepFormContext = createContext<StepFormContextType>(null);

export const useStepFormContext = () => {
  const context = useContext(StepFormContext);
  if (!context) {
    throw new Error('useStepFormContext must be used within the StepFormContext');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
  isEditing: boolean,
}

const StepFormContextProvider = ({ children, isEditing }: IProps) => (
  <StepFormContext.Provider value={ useStepForm(isEditing) }>
    { children }
  </StepFormContext.Provider>
);

export default StepFormContextProvider;
